<template>
<!-- 不在IP白名单内：安全验证 -->
	<div class="safety-ver">
    <a-card class="card" :body-style="{ padding: '111px 31px' }">
      <h2>安全验证</h2>
      <p>为了您的账号安全，请进行短信验证</p>
      <p class="text">已向您绑定的手机号<a>{{showPhone}}</a>发动验证码，请注意查收</p>
      <phone-code :code="code" :phoneHint="''" :phone="phone" @getCode="getCode" />
			<p class="tips">{{codeHint}}</p>
			<div class="btn-box">
        <a-button @click="goBack">取消</a-button>
        <a-button type="primary" @click="phoneLogin">确认</a-button>
      </div>
    </a-card>
	</div>
</template>

<script>
import PhoneCode from './phone-code.vue'

export default {
  props: {
    showPhone: String,
    codeHint: String,
    phone: String
  },
  data () {
    return {
      code: ''
    }
  },
  components: { PhoneCode },
  created () {
  },
  watch: {},
  methods: {
    // 取消
    goBack () {
      this.$emit('goBack')
    },
    // 获取code
    getCode (type, code) {
      this.code = code
    },
    // 确认
    phoneLogin () {
      this.$emit('phoneLogin', 'addIp', this.code)
    }
  }
}
</script>

<style lang="scss" scoped>
.safety-ver {
	margin-left: 40%;
	.card {
		width: 460px;
		border-radius: 20px;
		min-width: 450px;
		text-align: center;
		h2 {
			margin-bottom: 30px;
		}
		.text {
			text-align: left;
			margin-top: 8px;
			margin-bottom: 30px;
			color: #ccc;
		}
		.tips {
			text-align: left;
			color: red;
			margin-top: 3px;
			height: 25px;
		}
		.btn-box {
			margin-top: 40px;
			.ant-btn {
				width: 100px;
				margin-right: 15px;
				&:last-child {
					margin: 0;
				}
			}
		}
	}
}
</style>
